export default [
    {
        path: 'ria-parametrizacao',
        component: () => import(/* webpackChunkName: 'integracao-ria-parametrizacao' */ '@/views/integracao/ria/parametrizacao/Index'),
        redirect: 'ria-parametrizacao/create',
        children: [
            {
                name: 'integracao-ria-parametrizacao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'integracao-ria-parametrizacao' */ '@/views/integracao/ria/parametrizacao/Form'),
            },
        ],
    },
]